import React from 'react';
import store from '../_store/index';

// Create a context for the store
const StoreContext = React.createContext(null);

// Create a hook for using the store context
export const useStore = () => React.useContext(StoreContext);

// Create a provider component
export const StoreProvider = ({ children }) => {
  return (
    <StoreContext.Provider value={store}>
      {children}
    </StoreContext.Provider>
  );
};

export default StoreContext;